import React, { useState } from "react";

import { makeStyles, Typography } from "@material-ui/core";
import { createStyles, Theme } from "@material-ui/core/styles";
import CancelIcon from "@mui/icons-material/Cancel";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import ModalDialog from "../../../components/Form/ModalDialog";
import InputLabel from "../../../components/Form/InputLabel";
import Button from "../../../components/Button";
import Container from "../../../components/Container";
import reviewComment from "../../../assets/images/reviewComment.png";
import { SurveyStatus } from "../../../types/hospital";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    moreInfo: {
      textDecoration: "underline",
      marginLeft: theme.spacing(0.4),
      cursor: "pointer",
      textTransform: "lowercase",
    },
    editIcon: {
      fontSize: theme.spacing(2.2),
      color: theme.palette.primary.main,
    },
    title: {
      color: theme.palette.primary.main,
      display: "inline-block",
      fontSize: theme.spacing(2.5),
      fontWeight: "bold",
      margin: theme.spacing(1.8),
    },
    img: {
      width: "13rem",
      margin: theme.spacing(3, 0),
      [theme.breakpoints.only("xs")]: {
        width: "10rem",
      },
    },
    approved: {
      color: "#00C2BA",
      border: "1px solid #00C2BA",
    },
    denied: {
      color: "#E60012",
      border: "1px solid #E60012",
    },
    review: {
      color: "#FFA340",
      border: "1px solid #FFA340",
      textTransform: "none",
    },
  })
);

type NurseStatusBarProps = {
  status: SurveyStatus | null;
  icon: React.ReactNode;
  denyComment?: string;
};

export default function NurseStatusBar({
  status,
  icon,
  denyComment,
}: NurseStatusBarProps) {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const translateStatus = (status: SurveyStatus | null) => {
    switch (status) {
      case "DENIED":
        return "Odbijeno";
      case "REVIEW":
        return "U obradi";
      case "APPROVED":
        return "Odobreno";
    }
  };

  function findColor(status: string | null) {
    switch (status) {
      case "DENIED":
        return classes.denied;
      case "REVIEW":
        return classes.review;
      case "APPROVED":
        return classes.approved;
    }
  }

  function findIcon(status: string | null) {
    switch (status) {
      case "DENIED":
        return <CancelIcon />;
      case "REVIEW":
        return <QueryBuilderIcon />;
      case "APPROVED":
        return <CheckCircleIcon />;
    }
  }

  return (
    <Typography variant="button" className={findColor(status)}>
      <span style={{ marginRight: 8, display: "flex" }}>
        {findIcon(status)}
      </span>
      {translateStatus(status)}
      {status === "DENIED" && (
        <span>
          ,
          <span
            className={classes.moreInfo}
            onClick={() => {
              setModalOpen(true);
            }}
          >
            pročitaj više
          </span>
          {modalOpen && (
            <ModalDialog
              modalOpen={modalOpen}
              handleClose={() => setModalOpen(false)}
              maxWidth="md"
              title={
                <Typography className={classes.title}>
                  Zahtjev je odbijen.
                </Typography>
              }
              icon={<CancelIcon className={classes.editIcon} />}
            >
              <Container>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img
                    src={reviewComment}
                    alt="review comment"
                    className={classes.img}
                  />
                </div>
                <InputLabel>Razlog odbijanja:</InputLabel>
                <Typography>{denyComment}</Typography>
                <div style={{ display: "flex", justifyContent: "flex-end" }}>
                  <Button onClick={() => setModalOpen(false)}>U redu</Button>
                </div>
              </Container>
            </ModalDialog>
          )}
          .
        </span>
      )}
    </Typography>
  );
}
